module.exports = __webpack_public_path__ + "img/Savings.cab163a9.png";